@if (!(loading$ | async)) {
  <div class="flex flex-col p-4 gap-2" >
    <div class="flex flex-row justify-end gap-2">
      <button mat-button [matMenuTriggerFor]="currencyMenu">{{ currency$ | async }}</button>
      <mat-menu #currencyMenu>
        <button mat-menu-item (click)="changeCurrency('CAD')">CAD</button>
        <button mat-menu-item (click)="changeCurrency('USD')">USD</button>
        <button mat-menu-item (click)="changeCurrency('EUR')">EUR</button>
        <button mat-menu-item (click)="changeCurrency('GBP')">GBP</button>
      </mat-menu>
      <button mat-button [matMenuTriggerFor]="weightUnitMenu">{{ weightUnit$ | async }}</button>
      <mat-menu #weightUnitMenu>
        <button mat-menu-item (click)="changeWeightUnit(KG)">KG</button>
        <button mat-menu-item (click)="changeWeightUnit(LB)">LB</button>
      </mat-menu>
    </div>
    <app-commodity-form [formGroup]="formGroup" [currency]="currency$ | async" [weightUnit]="weightUnit$ | async">
    </app-commodity-form>
    <div class="flex flex-row justify-end gap-2">
      <button mat-button (click)="cancel()">CANCEL</button>
      @if (!(saving$ | async)) {
        <button mat-button (click)="submit()" [disabled]="disableSave$ | async">SAVE</button>
      }
      @if (saving$ | async) {
        <button mat-raised-button color="primary" [disabled]="true" i18n>
            SAVING
            <app-icon icon="spinner" [spin]="true"></app-icon>
        </button>
      }
    </div>
  </div>
}

@if (loading$ | async) {
  <div class="flex flex-col gap-4 m-16 justify-center items-center">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}